import {useMutation} from "@apollo/client";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {GQL_UPDATE_SLA_STATE} from "@/lib/queries/checks.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";
import {BulkSetSlaForm} from "@/pages/checks/list/actions/bulkSetSLA/BulkSetSlaForm.tsx";

export interface EditCheckSlaFormValues {
  msp_uptime_sla: string;
  msp_response_time_sla?: string;
}

export interface BulkSetSlaModalProps {
  selectedItemsIds: number[];
  show: boolean;
  setShow: (show: boolean) => void;
  onSuccess: () => void;
}

export const BulkSetSlaModal = ({selectedItemsIds, show, setShow, onSuccess}: BulkSetSlaModalProps) => {
  const [updateChecksSla, {data, loading}] = useMutation<GraphQLResponse<null>>(GQL_UPDATE_SLA_STATE);

  const handleSubmit = async (data: EditCheckSlaFormValues) => {
    const response = await updateChecksSla({
      variables: {
        input: {
          ids: selectedItemsIds,
          msp_uptime_sla: data.msp_uptime_sla,
          msp_response_time_sla:
            data.msp_response_time_sla === "" || data.msp_response_time_sla === undefined
              ? null
              : data.msp_response_time_sla,
        },
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
      onSuccess();
    }
  };

  const formId = "BulkSetSlaForm";
  return (
    <FormModal
      size="lg"
      disabled={loading}
      formId={formId}
      onCancel={() => setShow(false)}
      show={show}
      title={"Set uptime and response time SLA's"}
    >
      <BulkSetSlaForm
        formId={formId}
        onSubmit={handleSubmit}
        serverErrors={data?.response?.status === ResponseStatus.ERROR ? data.response.message : undefined}
        onError={console.log}
      />
    </FormModal>
  );
};
